import { render } from "./MyPolls.vue?vue&type=template&id=294988f4&ts=true"
import script from "./MyPolls.vue?vue&type=script&lang=ts"
export * from "./MyPolls.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__